<template>
	<div>
		<QuestionListItem
			v-for="(questionItem, id) in questionItems"
			:key="id"
			:question-item="questionItem"
			:mixpanel-element="props.mixpanelElement"
			:class="{ bb: id !== last }"
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { QuestionItem } from 'types/layout';
import QuestionListItem from '@components/layout/question-list-item.vue';

interface Props {
	questionItems: Array<QuestionItem>;
	mixpanelElement?: string;
}

const props = withDefaults(defineProps<Props>(), {
	mixpanelElement: 'button'
});

const last = computed((): number => {
	return props.questionItems.length - 1;
});
</script>
